// src/admin/lib/env.ts
// Reads env values from both Vite (`import.meta.env`, populated at build
// time from .env) and Node (`process.env`). At runtime in the browser,
// only Vite's injected values are present. Under ts-jest/ESM in tests,
// `import.meta.env` is undefined, so we fall back to process.env and the
// test runner populates it via jest.setup.
import { z } from 'zod';

const schema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(40),
  VITE_SENTRY_DSN: z.string().url().optional(),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
});

type ViteMeta = { env?: Record<string, string | undefined> };
const viteEnv: Record<string, string | undefined> =
  (import.meta as ViteMeta).env ?? {};
const nodeEnv: Record<string, string | undefined> =
  typeof process !== 'undefined' && process.env ? process.env : {};
// Vite values win at runtime; process.env is the fallback used only in tests.
const raw = { ...nodeEnv, ...viteEnv };

export const env = schema.parse({
  VITE_SUPABASE_URL: raw['VITE_SUPABASE_URL'],
  VITE_SUPABASE_ANON_KEY: raw['VITE_SUPABASE_ANON_KEY'],
  VITE_SENTRY_DSN: raw['VITE_SENTRY_DSN'],
  VITE_APP_ENV: raw['VITE_APP_ENV'] ?? 'development',
});

export type AppEnv = typeof env;
